import { Component, input } from '@angular/core';
import { UmssIconComponent } from '../../icon/icon.component';
@Component({
  selector: 'umss-card-header',
  standalone: true,
  imports: [UmssIconComponent],
  templateUrl: './card-header.component.html',
  styleUrl: './card-header.component.scss'
})
export class UmssCardHeaderComponent {
  iconName = input.required<string>();
  title = input.required<string>();
  iconSize = input<string>('20px');
}
